module.exports = __webpack_public_path__ + "img/green-energy.90851b4c.svg";